module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('amounts-component', {
    attrs: {
      "subsidiary-id": _vm.params.subsidiaryId
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.subsidiaries,
      "single-line": ""
    },
    on: {
      "input": _vm.onChangeHotel
    },
    model: {
      value: (_vm.params.subsidiaryId),
      callback: function($$v) {
        _vm.params.subsidiaryId = $$v
      },
      expression: "params.subsidiaryId"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "nameBuild",
      "item-value": "id",
      "label": "Edificio",
      "items": _vm.buildings,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadFloors
    },
    model: {
      value: (_vm.params.buildingId),
      callback: function($$v) {
        _vm.params.buildingId = $$v
      },
      expression: "params.buildingId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "label": "Tipo Hab.",
      "items": _vm.roomTypes,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.roomtypesId),
      callback: function($$v) {
        _vm.params.roomtypesId = $$v
      },
      expression: "params.roomtypesId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "label": "Estado",
      "items": _vm.statesFilter,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.stateId),
      callback: function($$v) {
        _vm.params.stateId = $$v
      },
      expression: "params.stateId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "offset-xs2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-btn pr-1",
    attrs: {
      "disabled": _vm.roomsNotSelected
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEditar\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "disabled": _vm.roomsNotSelected
    },
    on: {
      "click": _vm.cleanData
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLimpiar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-btn', {
    staticClass: "reservation-btn",
    attrs: {
      "disabled": !_vm.disabledReservation
    },
    on: {
      "click": _vm.reservation
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v("add")]), _vm._v("\n\t\t\t\t\t\t\t\tReserva\n\t\t\t\t\t\t\t")], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "planning-container"
  }, [_c('v-layout', {
    staticClass: "border-bottom",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "py-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "caption pl-1",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_vm._l((_vm.states), function(caption) {
    return _c('div', {
      key: caption.id,
      staticClass: "text-xs-left pr-4"
    }, [_c('span', {
      staticClass: "color",
      style: (("background-color: " + (caption.colorState)))
    }), _vm._v(" "), _c('label', {
      staticClass: "title"
    }, [_vm._v(_vm._s(caption.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left pr-4"
  }, [_c('span', {
    staticClass: "circle-booking"
  }, [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/booking-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("Reservado")])])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, _vm._l((_vm.rooms), function(room) {
    return _c('room-status', {
      key: room.id,
      attrs: {
        "background-color": room.colorState,
        "clean-state": room.cleanState,
        "code": room.codeRoomtype,
        "extra-state": room.extraState,
        "label-for": ("room-" + (room.id)),
        "number": room.codeRoom,
        "room": room,
        "show-circle": true,
        "status-icon-img": room.iconUrl
      },
      on: {
        "on-room-selected": _vm.roomIsSelected
      }
    })
  }))], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": 685
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "modal-card"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Cambiar de estado")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "modal-row",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "px-2": "",
      "justify-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "py-2": ""
    }
  }, [_c('label', {
    staticClass: "modal-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tHabitaciones seleccionadas\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, _vm._l((_vm.roomsSelected), function(room) {
    return _c('room-status', {
      key: room.id,
      attrs: {
        "background-color": room.colorState,
        "clean-state": room.cleanState,
        "code": room.codeRoomtype,
        "extra-state": room.extraState,
        "label-for": ("room-" + (room.id)),
        "number": room.codeRoom,
        "room": room,
        "show-circle": true,
        "status-icon-img": room.iconUrl
      },
      on: {
        "on-room-selected": _vm.roomIsSelected
      }
    })
  }))], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "info": "",
      "x-large": ""
    }
  }, [_vm._v("arrow_downward")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "modal-row",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "px-2": "",
      "justify-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "py-2": ""
    }
  }, [_c('label', {
    staticClass: "modal-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tDefine el estado de las habitaciones\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l((_vm.states), function(state) {
    return _c('room-status', {
      key: state.id,
      attrs: {
        "background-color": state.colorState,
        "clean-state": state.clean_state,
        "code": state.code_roomtype,
        "extra-state": state.extra_state,
        "label-for": ("state-" + (state.id)),
        "name": state.name,
        "number": state.number,
        "room": state,
        "status-icon-img": state.icon_url
      },
      on: {
        "on-room-selected": _vm.stateIsSelected
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "info": "",
      "disabled": _vm.roomsNotSelected
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeState($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCambiar\n\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1ee6302","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/planning/List.vue
// module id = 1701
// module chunks = 56